import { render, staticRenderFns } from "./SupplierManualDir.vue?vue&type=template&id=bb793826&scoped=true&lang=pug&"
import script from "./SupplierManualDir.vue?vue&type=script&lang=js&"
export * from "./SupplierManualDir.vue?vue&type=script&lang=js&"
import style0 from "./SupplierManualDir.vue?vue&type=style&index=0&id=bb793826&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb793826",
  null
  
)

export default component.exports